import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../services/api';

const INPUT_STYLE = {
  padding: '13px 14px',
  borderRadius: 12,
  border: '1.5px solid #e8e4de',
  fontSize: '16px',
  fontFamily: "'Sora', sans-serif",
  background: '#fff',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
  WebkitAppearance: 'none',
};

export default function EsqueciSenha() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const empresaId = params.get('empresa_id');

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Informe seu e-mail'); return; }
    if (!empresaId) { toast.error('Loja não identificada'); return; }

    setLoading(true);
    try {
      await api.post('/auth/solicitar-reset', { email, empresa_id: empresaId });
      setEnviado(true);
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao enviar email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100dvh', background: '#F8F7F4', fontFamily: "'Sora', sans-serif" }}>
      <header style={{
        background: '#1A1A2E',
        padding: '16px 20px',
        paddingTop: 'max(16px, env(safe-area-inset-top))',
      }}>
        <div style={{ maxWidth: 480, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate(-1)} style={{
            background: 'rgba(255,255,255,.1)', border: 'none', color: '#fff',
            borderRadius: 10, width: 38, height: 38, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem',
            flexShrink: 0,
          }}>←</button>
          <h1 style={{ color: '#fff', fontSize: '1rem', fontWeight: 800, margin: 0 }}>
            Esqueci minha senha
          </h1>
        </div>
      </header>

      <div style={{ maxWidth: 480, margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ background: '#fff', borderRadius: 20, padding: '32px 24px',
          boxShadow: '0 4px 24px rgba(0,0,0,.07)' }}>

          {enviado ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: 16 }}>📧</div>
              <h2 style={{ margin: '0 0 12px', color: '#1A1A2E', fontSize: '1.1rem', fontWeight: 800 }}>
                Email enviado!
              </h2>
              <p style={{ margin: '0 0 28px', color: '#666', fontSize: '.9rem', lineHeight: 1.6 }}>
                Se o email <strong>{email}</strong> estiver cadastrado, você receberá as instruções para redefinir sua senha em breve.
              </p>
              <p style={{ margin: '0 0 28px', color: '#888', fontSize: '.82rem', lineHeight: 1.6 }}>
                Verifique também sua caixa de spam.
              </p>
              <button onClick={() => navigate(-1)} style={{
                background: '#FF6B35', color: '#fff', border: 'none', borderRadius: 14,
                padding: '13px 28px', fontWeight: 800, fontSize: '.95rem',
                cursor: 'pointer', fontFamily: 'inherit',
                boxShadow: '0 4px 16px rgba(255,107,53,.3)',
              }}>
                Voltar ao login
              </button>
            </div>
          ) : (
            <>
              <h2 style={{ margin: '0 0 8px', color: '#1A1A2E', fontSize: '1.1rem', fontWeight: 800 }}>
                Redefinir senha
              </h2>
              <p style={{ margin: '0 0 24px', color: '#888', fontSize: '.875rem', lineHeight: 1.6 }}>
                Informe o email da sua conta e enviaremos um link para criar uma nova senha.
              </p>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <label style={{ fontSize: '.8rem', fontWeight: 700, color: '#444' }}>E-mail *</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="seu@email.com"
                    style={INPUT_STYLE}
                    onFocus={e => e.target.style.borderColor = '#FF6B35'}
                    onBlur={e => e.target.style.borderColor = '#e8e4de'}
                    autoFocus
                  />
                </div>
                <button type="submit" disabled={loading} style={{
                  background: loading ? '#ccc' : '#FF6B35',
                  color: '#fff', border: 'none', borderRadius: 14,
                  padding: '14px', fontWeight: 800, fontSize: '1rem',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontFamily: 'inherit',
                  boxShadow: loading ? 'none' : '0 4px 16px rgba(255,107,53,.3)',
                }}>
                  {loading ? 'Enviando...' : 'Enviar link de redefinição'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
